import classNames from 'classnames';
import { ControlProps, TextArea, TextAreaProps } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './TextAreaDecorator.css';

export type TextAreaDecoratorProps = TextAreaProps &
    ControlProps & {
        valid?: boolean;
        cls?: string;
    };

const BLOCK = 'textarea-decorator';

export class TextAreaDecorator extends React.Component<
    TextAreaDecoratorProps & ControlProps
> {
    render() {
        const { cls, valid, ...passThroughProps } = this.props;

        return (
            <div className={classNames(Bem.cls(BLOCK), cls)}>
                <TextArea
                    {...passThroughProps}
                    cls={Bem.cls({
                        block: BLOCK,
                        elem: 'input',
                        mods: { valid: valid ? 'yes' : 'no' }
                    })}
                />
            </div>
        );
    }
}
